import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './containers/Home';
import AISolutions from './containers/Pages/AISolutions';
import AIAutomation from './containers/Pages/AIAutomation';
import AIAgents from './containers/Pages/AIAgents';
import RetailEcommerce from './containers/Pages/RetailEcommerce';
import Healthcare from './containers/Pages/Healthcare';
import Logistics from './containers/Pages/Logistics';
import Finance from './containers/Pages/Finance';
import ProfessionalServices from './containers/Pages/ProfessionalServices';
import Enterprise from './containers/Pages/Enterprise';
import HowItWorks from './containers/Pages/HowItWorks';
import Contact from './containers/Pages/Contact';
import BookDemo from './containers/Pages/BookDemo';
import Login from './containers/Pages/Login';
import PrivacyPolicy from './containers/Pages/PrivacyPolicy';
import TermsConditions from './containers/Pages/TermsConditions';



function App() {
  return (
    <div className="App">
      <Router>


        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/ai-solutions' element={<AISolutions />} />
          <Route exact path='/ai-automation' element={<AIAutomation />} />
          <Route exact path='/ai-agents' element={<AIAgents />} />
          <Route exact path='/retail' element={<RetailEcommerce />} />
          <Route exact path='/healthcare' element={<Healthcare />} />
          <Route exact path='/logistics' element={<Logistics />} />
          <Route exact path='/finance' element={<Finance />} />
          <Route exact path='/professional-services' element={<ProfessionalServices />} />
          <Route exact path='/enterprise' element={<Enterprise />} />
          <Route exact path='/how-it-works' element={<HowItWorks />} />
          <Route exact path='/contact' element={<Contact />} />
          <Route exact path='/book-demo' element={<BookDemo />} />
          <Route exact path='/login' element={<Login />} />
          <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route exact path='/terms-conditions' element={<TermsConditions />} />


        </Routes>
      </Router>
    </div>
  );
}

export default App;